export const listRoutes = async params => {
  return await window.$vue.$get({ endpoint: "/route", params })
}

export const fetchRoute = async uuid => {
  return await window.$vue.$get({ endpoint: `/route/${uuid}` })
}

export const createRoute = async data => {
  return await window.$vue.$post({
    endpoint: `/route`,
    data
  })
}

export const fetchMyRoute = async () => {
  return await window.$vue.$get({ endpoint: "/route/my-route" })
}

export const editRoute = async data => {
  return await window.$vue.$put({
    endpoint: `/route/${data.uuid}`,
    data
  })
}

export const startRoute = async uuid => {
  return await window.$vue.$put({
    endpoint: `/route/${uuid}/start`
  })
}

export const pauseRoute = async uuid => {
  return await window.$vue.$put({
    endpoint: `/route/${uuid}/pause`
  })
}

export const finishRoute = async uuid => {
  return await window.$vue.$put({
    endpoint: `/route/${uuid}/finish`
  })
}

export const listSellers = async params => {
  return await window.$vue.$get({
    endpoint: `/user/list-led-sellers`,
    params
  })
}

export const listStatuses = async () => {
  return await window.$vue.$get({
    endpoint: "/route/statuses"
  })
}

export const listUsers = async () => {
  return await window.$vue.$get({
    endpoint: "/route/created-by-users"
  })
}

export const listLayersTree = async () => {
  return await window.$vue.$get({
    endpoint: "/route/layers-tree"
  })
}

export const fetchLayer = async params => {
  return await window.$vue.$get({
    endpoint: "/route/layer",
    params
  })
}

export const fetchRouteDetail = async uuid => {
  return await window.$vue.$get({
    endpoint: `/route/detail`,
    params: { route_uuid: uuid }
  })
}

export const fetchIndicatorsDashboard = async params => {
  return await window.$vue.$get({
    endpoint: "/route/indicators",
    params
  })
}

export const fetchRolesUser = async params => {
  return await window.$vue.$get({
    endpoint: "/route/indicators-role-user",
    params
  })
}
